import type { Note } from '@/types';

import { enqueueStructuredEntityWrite, type StructuredEntityWriteRegistration } from './structured-entity-write';
import type { ProjectScope } from './project-scope';

const NOTE_METADATA_WRITE_REGISTRATION: StructuredEntityWriteRegistration = {
    feature: 'notes_reports',
    capability: 'EDIT_NOTES',
    conflictPrefix: 'notes',
    allowedKinds: ['patchEntity', 'deleteEntity'],
    authErrorMessage: 'Authentication required to preserve note project writes',
};

type NoteMetadata = Omit<Note, 'content'>;

function noteMetadataPayload(note: Note): NoteMetadata {
    const {
        content: _content,
        ...metadata
    } = note;
    return metadata;
}

export async function saveNoteMetadata(scope: ProjectScope, note: Note): Promise<void> {
    await enqueueStructuredEntityWrite({
        scope,
        registration: NOTE_METADATA_WRITE_REGISTRATION,
        entityId: note.id,
        kind: 'patchEntity',
        payload: noteMetadataPayload(note),
    });
}

export async function deleteNoteMetadata(scope: ProjectScope, noteId: string): Promise<void> {
    await enqueueStructuredEntityWrite({
        scope,
        registration: NOTE_METADATA_WRITE_REGISTRATION,
        entityId: noteId,
        kind: 'deleteEntity',
        payload: { id: noteId },
    });
}
